// extracted by mini-css-extract-plugin
module.exports = {"title":"e_ox","author":"e_px","container":"e_qx","image":"e_rx","uiHolder":"e_sx"};